import React, { useEffect } from 'react';
import AppRouter from './routing/AppRouter';
import { useBranding } from './hooks/useBranding';

function App() {
  useBranding();
  useEffect(() => {
    console.log('Commit hash:', __COMMIT_HASH__);
  }, []);
  return <AppRouter />;
}

export default App;
